import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { WHATS_NEW, TAG_STYLE, fmtNewsDate } from "@/data/whatsNew";
import { getWhatsNew } from "@/lib/api";

export const WhatsNewTeaser = () => {
  const [all, setAll] = useState(WHATS_NEW);
  useEffect(() => { getWhatsNew().then((d) => { if (d?.items?.length) setAll(d.items); }).catch(() => {}); }, []);
  const items = all.slice(0, 3);
  return (
    <section data-testid="whats-new-teaser" className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brand"><Sparkles size={13} /> What's New</span>
            <h2 className="font-heading text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 mt-3">Fresh tools, shipped continuously</h2>
          </div>
          <Link to="/whats-new" data-testid="whats-new-view-all" className="inline-flex items-center gap-2 font-semibold rounded-xl px-5 py-3 btn-outline whitespace-nowrap">See all updates <ArrowRight size={16} /></Link>
        </div>
        <div className="grid md:grid-cols-3 gap-5 mt-10">
          {items.map((n, i) => {
            const Card = n.to ? Link : "div";
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}>
                <Card {...(n.to ? { to: n.to } : {})} className="block h-full bg-slate-50 border border-slate-200 rounded-2xl p-6 card-shadow hover:-translate-y-1 transition-transform" data-testid={`whats-new-teaser-${i}`}>
                  <div className="flex items-center gap-3">
                    <span className={`text-[11px] font-semibold px-2.5 py-0.5 rounded-full ${TAG_STYLE[n.tag] || "bg-slate-100 text-slate-600"}`}>{n.tag}</span>
                    <span className="text-xs text-slate-400">{fmtNewsDate(n.date)}</span>
                  </div>
                  <h3 className="font-heading font-bold text-slate-900 text-lg mt-3">{n.title}</h3>
                  <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{n.desc}</p>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
